export default __webpack_public_path__ + "aa27eca.png";